import ExpertTypeFilter from './expert-type.filter';
import IndustryFilter from './industry.filter';
import TransformToTitleCaseFilter from './title-case.filter';

const FilterModule = angular
  .module('filters.expertFinder', [])
  .filter('filterByExpertType', () => ExpertTypeFilter)
  .filter('filterByIndustry', () => IndustryFilter)
  .filter('transformToTitleCase', () => TransformToTitleCaseFilter);

export default FilterModule;



// WEBPACK FOOTER //
// ./src/filters/index.js